import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { SponsorRepresentative } from '../data-models/sponsor-representative.model';
import { SponsorRepresentativeCreateRequest } from '../request-models/sponsor-representative-create-request.model';
import { SponsorRepresentativeUpdateRequest } from '../request-models/sponsor-representative-update-request.model';
import { toSponsorRepresentativeCreateRequest, toSponsorRepresentativeUpdateRequest } from '../utils/sponsor-request-utils';
import { sponsorPrefix } from '../utils/sponsor-path-utils';

/**
 * A sponsor's sales representatives: `/admin/sponsors/:sponsorId/representatives`
 * (hub `admin-sponsors-controller.ts`).
 */
@Injectable({ providedIn: 'root' })
export class SponsorRepresentativeService extends BaseService<SponsorRepresentative> {
  constructor() {
    super('representatives', SponsorRepresentative);
  }

  /** GET /admin/sponsors/:sponsorId/representatives */
  listRepresentatives(sponsorId: string): Observable<SponsorRepresentative[]> {
    return this.getMany({ prefix: sponsorPrefix(sponsorId) });
  }

  /** POST /admin/sponsors/:sponsorId/representatives */
  createRepresentative(sponsorId: string, fields: SponsorRepresentativeCreateRequest): Observable<SponsorRepresentative | null> {
    return this.create(toSponsorRepresentativeCreateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** PUT /admin/sponsors/:sponsorId/representatives/:repId with only the fields that are set. */
  updateRepresentative(
    sponsorId: string,
    repId: string,
    fields: SponsorRepresentativeUpdateRequest
  ): Observable<SponsorRepresentative | null> {
    return this.update(repId, toSponsorRepresentativeUpdateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** DELETE /admin/sponsors/:sponsorId/representatives/:repId (archive). */
  archiveRepresentative(sponsorId: string, repId: string): Observable<void> {
    return this.delete(repId, { prefix: sponsorPrefix(sponsorId) });
  }
}
